import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import isEqual from 'lodash/isEqual';
import { codeBlockToJSON, dataConsumerToJSON, expandToJSON, fragmentToJSON, linkToJSON, mediaSingleToJSON, mediaToJSON, mentionToJSON, tableToJSON, toJSONTableCell, toJSONTableHeader } from '@atlaskit/adf-schema';
import { getSchemaBasedOnStage } from '@atlaskit/adf-schema/schema-default';
import { markOverrideRuleFor } from './markOverrideRules';
import { sanitizeNode } from './sanitize/sanitize-node';
export var SchemaStage = /*#__PURE__*/function (SchemaStage) {
  SchemaStage["FINAL"] = "final";
  SchemaStage["STAGE_0"] = "stage0";
  return SchemaStage;
}({});
var isType = function isType(type) {
  return function (node) {
    return node.type.name === type;
  };
};
var isCodeBlock = isType('codeBlock');
var isMediaNode = isType('media');
var isMediaInline = isType('mediaInline');
var isMediaSingleNode = isType('mediaSingle');
var isMentionNode = isType('mention');
var isParagraph = isType('paragraph');
var isHeading = isType('heading');
var isTable = isType('table');
var isTableCell = isType('tableCell');
var isTableHeader = isType('tableHeader');
var isLinkMark = isType('link');
var isUnsupportedMark = isType('unsupportedMark');
var isUnsupportedNodeAttributeMark = isType('unsupportedNodeAttribute');
var isExpand = isType('expand');
var isNestedExpand = isType('nestedExpand');
var isUnsupportedNode = function isUnsupportedNode(node) {
  return isType('unsupportedBlock')(node) || isType('unsupportedInline')(node);
};
var isDataConsumer = isType('dataConsumer');
var isFragmentMark = isType('fragment');
var filterNull = function filterNull(subject) {
  var output = _objectSpread({}, subject);
  for (var key in output) {
    var current = output[key];
    if (current === null) {
      var _output = output,
        unusedKey = _output[key],
        filteredObj = _objectWithoutProperties(_output, [key].map(_toPropertyKey));
      output = filteredObj;
    } else if (_typeof(current) === 'object' && !Array.isArray(current)) {
      output[key] = filterNull(current);
    }
  }
  return output;
};
var createDocFromContent = function createDocFromContent(content) {
  return {
    version: 1,
    type: 'doc',
    content: content || []
  };
};
var emptyDoc = createDocFromContent([{
  type: 'paragraph',
  content: []
}]);
var toJSON = function toJSON(node) {
  var obj = {
    type: node.type.name
  };
  if (isUnsupportedNode(node)) {
    return node.attrs.originalValue;
  } else if (isMediaNode(node)) {
    obj.attrs = mediaToJSON(node).attrs;
  } else if (isMediaSingleNode(node)) {
    obj.attrs = mediaSingleToJSON(node).attrs;
  } else if (isMediaInline(node)) {
    obj.attrs = mediaToJSON(node).attrs;
  } else if (isMentionNode(node)) {
    obj.attrs = mentionToJSON(node).attrs;
  } else if (isCodeBlock(node)) {
    obj.attrs = codeBlockToJSON(node).attrs;
  } else if (isTable(node)) {
    obj.attrs = tableToJSON(node).attrs;
  } else if (isTableCell(node)) {
    obj.attrs = toJSONTableCell(node).attrs;
  } else if (isTableHeader(node)) {
    obj.attrs = toJSONTableHeader(node).attrs;
  } else if (isExpand(node) || isNestedExpand(node)) {
    obj.attrs = expandToJSON(node).attrs;
  } else if (node.attrs && Object.keys(node.attrs).length) {
    obj.attrs = node.attrs;
  }
  if (obj.attrs) {
    obj.attrs = filterNull(obj.attrs);
  }
  if (node.isText) {
    obj.text = node.textContent;
  } else {
    node.content.forEach(function (child) {
      obj.content = obj.content || [];
      obj.content.push(toJSON(child));
    });
  }
  if (isParagraph(node) || isHeading(node)) {
    obj.content = obj.content || [];
  }
  if (node.marks.length) {
    // Run any custom mark serialisers
    var parsedMarks = node.marks.map(function (mark) {
      if (isUnsupportedMark(mark)) {
        return canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
      } else if (isUnsupportedNodeAttributeMark(mark)) {
        return null;
      } else if (isLinkMark(mark)) {
        return linkToJSON(mark);
      } else if (isDataConsumer(mark)) {
        var _serialised$attrs$sou;
        var serialised = dataConsumerToJSON(mark);
        return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
      } else if (isFragmentMark(mark)) {
        var fragmentMark = fragmentToJSON(mark);
        if (!fragmentMark.attrs.localId) {
          return null;
        }
        return fragmentMark;
      } else {
        return mark.toJSON();
      }
    }).filter(function (maybeMark) {
      return maybeMark !== null;
    });

    // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
    obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
    var nodeAttributeMark = node.marks.find(isUnsupportedNodeAttributeMark);
    if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) {
      obj.attrs = _objectSpread({}, getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
  }
  return obj;
};
var canOverrideMark = function canOverrideMark(mark, existingMarks) {
  if (existingMarks.some(function (e) {
    return mark.attrs.originalValue.type === e.type.name;
  })) {
    return markOverrideRuleFor(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
  }
  return false;
};
var getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
  var nodeAttributes = node.type.spec.attrs;
  var attributes = _objectSpread(_objectSpread({}, mark.attrs.unsupported), obj.attrs);
  for (var key in obj.attrs) {
    if (obj.attrs.hasOwnProperty(key)) {
      var attribute = nodeAttributes ? nodeAttributes[key] : null;
      if (attribute) {
        if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) {
          return _objectSpread(_objectSpread({}, attributes), {}, _defineProperty({}, key, mark.attrs.unsupported[key]));
        }
      }
    }
  }
  return attributes;
};
export var JSONTransformer = /*#__PURE__*/function () {
  function JSONTransformer() {
    _classCallCheck(this, JSONTransformer);
  }
  _createClass(JSONTransformer, [{
    key: "encode",
    value: function encode(node) {
      var content = [];
      node.content.forEach(function (child) {
        content.push(sanitizeNode(toJSON(child)));
      });
      if (!content || isEqual(content, emptyDoc.content)) {
        return createDocFromContent([]);
      }
      return createDocFromContent(content);
    }
  }, {
    key: "internalParse",
    value: function internalParse(content) {
      var stage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SchemaStage.FINAL;
      var schema = getSchemaBasedOnStage(stage);
      var doc = schema.nodeFromJSON(content);
      doc.check();
      return doc;
    }
  }, {
    key: "parse",
    value: function parse(content, stage) {
      if (content.type !== 'doc') {
        throw new Error('Expected content format to be ADF');
      }
      if (!content.content || content.content.length === 0) {
        return this.internalParse(emptyDoc, stage);
      }
      return this.internalParse(content, stage);
    }

    /**
     * This method is used to encode a single node
     */
  }, {
    key: "encodeNode",
    value: function encodeNode(node) {
      return sanitizeNode(toJSON(node));
    }
  }]);
  return JSONTransformer;
}();